export default __webpack_public_path__ + "static/media/background3.9c23900d.png";